import {useMemo} from 'react';
import {debounce} from 'lodash';
import type {DebounceOptions} from '../debounce';
import useLatest from '../latest';
import useUnmount from '../unmount';

function useDebounceFn<T extends Func>(fn: T, options?: DebounceOptions) {
    const fnRef = useLatest(fn);
    const wait = options?.wait ?? 1000;
    const debounced = useMemo(() => debounce(
        (...args: Parameters<T>): ReturnType<T> => fnRef.current(...args),
        wait,
        options
    ), []);

    useUnmount(() => {
        debounced.cancel();
    });

    return {
        run: debounced,
        cancel: debounced.cancel,
        flush: debounced.flush
    };
}

export default useDebounceFn;